import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@cloudscape-design/global-styles/index.css';
import { applyMode, Mode } from '@cloudscape-design/global-styles';
import { initAuth } from './apis/midwayAuth';

// Capture Midway token from URL before React router processes the URL
initAuth();

applyMode(Mode.Dark);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
